import * as d3 from 'd3';

import Component, {ComponentOptions} from 'molbio/maps/linear/Component';
import {Title} from 'molbio/maps/linear/LinearLayout';
import Slice from 'molbio/maps/linear/Slice';

export interface TitleViewOptions extends ComponentOptions {
  slice: Slice;
  bufferCentred: boolean;
}

class TitleView extends Component {
  slice!: Slice;
  bufferCentred!: boolean;
  layout!: Title;

  static initClass(): void {
    this.prototype.className = 'title';
    this.prototype.setting = null;
  }

  initialize(options: TitleViewOptions): void {
    super.initialize(options);
    this.slice = options.slice;
    this.bufferCentred = options.bufferCentred;
    this.layout = this.model.get('layout').Title;
  }

  registerListeners(): void {
    super.registerListeners();
    this.listenTo(
      this.slice,
      this.bufferCentred ? 'change:visibleWidth' : 'change:width',
      this.update.bind(this)
    );
    this.listenTo(this.model.get('sequence').get('_sequence'), 'change:name', this.update.bind(this));
    return this.listenTo(
      this.model.get('sequence').get('dna'),
      'change:forward change:reverse',
      this.update.bind(this)
    );
  }

  shouldShow(): boolean {
    return true;
  }

  update(): void {
    const text = `${this.model.get('sequence').get('_sequence').displayNames()} (${this.model
      .get('sequence')
      .get('_sequence')
      .length()} bp)`;

    d3.select(this.el)
      .select('.component-wrapper')
      .selectAll('text.title-text')
      .data([text])
      .join('text')
      .classed('title-text', true)
      .attr('font-size', this.layout.get('type').fontSize)
      .attr('y', this.layout.get('type').height())
      .attr('text-anchor', 'middle')
      .attr('x', this.bufferCentred ? this.slice.get('visibleWidth')! / 2 : this.slice.get('width')! / 2)
      .text(text);
  }
}
TitleView.initClass();

export default TitleView;
